import { useLingui } from '@lingui/react/macro';

import { MobileEntityFilter } from '@/components/SharedFilters/EntityFilter/MobileEntityFilter';
import IconAssociate from '@/icons/Associate.svg';

import { useFilters } from '../FiltersState';

export const FiltersEntity = () => {
  const { t } = useLingui();

  const {
    entities: { entities, setEntities },
  } = useFilters();

  return (
    <MobileEntityFilter
      filterId="entity"
      selectedEntities={entities}
      setSelectedEntities={setEntities}
      includeGroups={false}
      label={t({
        id: 'settings.organization.members.users.filters.entity.label',
        message: 'Entity',
      })}
      searchPlaceholder={t({
        id: 'settings.organization.members.users.filters.entity.search',
        message: 'Search entities',
      })}
      icon={<IconAssociate />}
    />
  );
};
